<script>
import { useAlert } from 'dashboard/composables';
import InputRadioGroup from 'dashboard/components/widgets/conversation/InputRadioGroupStylizedAsButton.vue';

export default {
  components: { InputRadioGroup },
  props: {
    inboxId: {
      type: Number,
      required: true,
    },
    initialResolutionType: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      title: '',
      isLoading: false,
      selectedResolutionType: this.initialResolutionType,
      resolutionOptions: [
        {
          id: 'objective_achieved',
          title: this.$t('CONVERSATION.RESOLUTION_MODAL.OPTIONS.FIRST_LABEL'),
          checked: false,
        },
        {
          id: 'objective_not_achieved',
          title: this.$t('CONVERSATION.RESOLUTION_MODAL.OPTIONS.SECOND_LABEL'),
          checked: false,
        },
        {
          id: 'doubt',
          title: this.$t('CONVERSATION.RESOLUTION_MODAL.OPTIONS.THIRD_LABEL'),
          checked: false,
        },
        {
          id: 'other',
          title: this.$t('CONVERSATION.RESOLUTION_MODAL.OPTIONS.FOURTH_LABEL'),
          checked: false,
        },
      ],
    };
  },
  computed: {},
  mounted() {
    const currentOption = this.resolutionOptions.find(
      e => e.id === this.initialResolutionType
    );
    if (currentOption) currentOption.checked = true;
  },
  methods: {
    async createReason() {
      const payload = {
        inboxId: this.inboxId,
        title: this.title,
        resolutionType: this.selectedResolutionType,
      };
      try {
        this.isLoading = true;
        await this.$store.dispatch(
          'inboxes/createConversationResolutionReason',
          payload
        );
        this.onClose();
        useAlert(
          this.$t(
            'INBOX_MGMT.EDIT.CONVERSATION_RESOLUTION.REASONS.CREATE.API.SUCCESS_MESSAGE'
          )
        );
      } catch (error) {
        useAlert(
          this.$t(
            'INBOX_MGMT.EDIT.CONVERSATION_RESOLUTION.REASONS.CREATE.API.ERROR_MESSAGE'
          )
        );
        this.isLoading = false;
      }
    },
    onChangeResolutionOption(selectedOption) {
      this.selectedResolutionType = selectedOption;
    },
    onClose() {
      this.$emit('close');
    },
  },
};
</script>

<template>
  <div class="h-auto overflow-auto flex flex-col pb-5">
    <woot-modal-header
      :header-title="
        $t('INBOX_MGMT.EDIT.CONVERSATION_RESOLUTION.REASONS.CREATE.HEADER')
      "
    />
    <div class="pl-8">
      <label>{{
        $t(
          'INBOX_MGMT.EDIT.CONVERSATION_RESOLUTION.REASONS.CREATE.RESOLUTION_TYPE'
        )
      }}</label>
      <InputRadioGroup
        name="widget-screen"
        class="mb-3"
        :items="resolutionOptions"
        :initial-option="selectedResolutionType"
        @on-change-resolution-option="onChangeResolutionOption"
      />
      <woot-input
        v-model.trim="title"
        v-tooltip.bottom="title"
        class="w-full pr-10"
        :label="
          $t('INBOX_MGMT.EDIT.CONVERSATION_RESOLUTION.REASONS.CREATE.LABEL')
        "
        :placeholder="
          $t(
            'INBOX_MGMT.EDIT.CONVERSATION_RESOLUTION.REASONS.CREATE.PLACE_HOLDER'
          )
        "
      />

      <div class="flex justify-end items-center py-2 px-0 gap-2 w-full">
        <woot-button :is-loading="isLoading" @click="createReason">
          {{ $t('LABEL_MGMT.FORM.CREATE') }}
        </woot-button>
        <woot-button
          :is-loading="isLoading"
          class="button clear"
          @click="onClose"
        >
          {{ $t('LABEL_MGMT.FORM.CANCEL') }}
        </woot-button>
      </div>
    </div>
  </div>
</template>
